module.exports = __webpack_public_path__ + "img/file-earmark-lock2.b6f97336.svg";